module.exports = __webpack_public_path__ + "zl4-a8a70303.png";